import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  void: {
    defaultMessage: 'Void',
    description: 'Void label'
  },
  voidReprint: {
    defaultMessage: 'Void & Reprint',
    description: 'Void Reprint label'
  },
  postSelected: {
    defaultMessage: 'Post Selected',
    description: 'Post Selected label'
  },
  retry: {
    defaultMessage: 'Retry',
    description: 'Retry failed void'
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    description: 'Dismiss void failure message'
  }
});

export const gridHeaders = defineMessages({
  vendorNo: {
    defaultMessage: 'Vendor No.',
    description: 'Grid header for vendor number'
  },
  vendorName: {
    defaultMessage: 'Vendor Name',
    description: 'Grid header for vendor name'
  },
  checkNo: {
    defaultMessage: 'Check No.',
    description: 'Grid header for check number'
  },
  amount: {
    defaultMessage: 'Amount($)',
    description: 'Grid header for amount'
  },
  printedOK: {
    defaultMessage: 'Printed OK?',
    description: 'Grid header for printed ok'
  }
});

export const errors = defineMessages({
  voidError: {
    defaultMessage:
      'Check {checkNumber} failed to Void, please try again. If issue persists, contact CDK Support.',
    description: 'show this error message when void fails from api'
  },
  glError: {
    defaultMessage:
      'Failure when attempting to update General Ledger.  Please call support',
    description: 'show this error message when print fails while updating GL'
  },
  archiveError: {
    defaultMessage:
      'Check {checkNumber} failed to archive accounting copy. Please make copy for records',
    description: 'show this error message when print fails while archiving'
  },
  checkFormRenderError: {
    defaultMessage:
      'Check number assigned but form did not render.  Please void and adjust sequence if needed.',
    description:
      'show this error message when print fails while rendering check form'
  }
});
